import React from 'react'
import {
  Button,
  Col,
  FormGroup,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Input,
  Form, 
} from 'reactstrap' 
import Swal from 'sweetalert2'
import { MiniLoading, AsyncTypeahead, DatePicker, Loading, Select } from "../../components/revel-strap"  
class UpdateModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      is_loading: true,
      index_buffers: [], 
      news_code: '', 
      news_detail: '',
      
    }
  }

  componentDidUpdate(props_old) {
    if (!props_old.show && this.props.show) {
      this._fetchData()
    }
  }

  _fetchData = () => this.setState({ is_loading: true, index_buffers: [], }, async () => {

    const { news_code, news_detail } = this.props  
   
    this.setState({
      is_loading: false,   
      news_code: news_code,  
      news_detail: news_detail,  
    })
  }) 
 
  _handleClose = () => this.props.onClose()

  render() {
    

    return (
      <Modal style={{ maxWidth: "60%", width: "60%" }} centered isOpen={this.props.show} toggle={this._handleClose}>
        <ModalHeader toggle={this._handleClose}><h3 className="text-header"> รายละเอียดข่าวสาร / News Detail</h3></ModalHeader>
        <ModalBody>
          {this.state.is_loading ? (
            <div className="text-center pt-4">
              <MiniLoading className="mx-auto" /> กำลังโหลดข้อมูล
            </div>
          ) : (
            <Card>
            <CardBody> 
              <p> 
                {this.state.news_detail}
              </p>  
            </CardBody>
          </Card>
          )}
        </ModalBody>
        <ModalFooter> 
          <Button type="button" onClick={this._handleClose}>Back</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default UpdateModal